<template>
  <div style="height: 100%;">
    <page class="service" v-if="$route.path === '/service'">
      <zui-header :borderGrey="true" :navConfigList="navConfigList"></zui-header>
      <PageNavigater></PageNavigater>
      <!--经典线路-->
      <div class="one" id="one">
        <div class="title"></div>
        <cms-article-list :pid="$cid.intro.jingDianXianLu" :limit="10" :parse-function="xinLuParse" :sort-by="1" class="xianlu">
          <template slot-scope="{ list }">
            <div class="nav clear">
              <div class="vivify fadeInRight" v-for="(item, index) in list" :key="item.id" :class="[ active === index?'active':'','delay-'+index*1000 ]"
                :style="{ backgroundImage: active === index ? 'none' : 'url(' + item._cover + ')' }" @mouseover="active=index" @mouseleave="active=index">
                <div class="left">
                  <logo :type="index + 1" class="logoT"></logo>
                  <h3>{{ item.title }}</h3>
                  <div class="des" v-if="item.ext1 && item.ext1.length > 0">

                    <div class="timeline" v-for="(activity, idx) in item.activities" :key="idx">
                      <div class="dot" :class="{ dot1: idx === 3}"></div>
                      <div class="text" :title="activity">{{activity}}</div>
                    </div>
                      <!-- <el-timeline>
                        <el-timeline-item v-for="(activity, idx) in item.activities" :key="idx" size="large">
                          <div class="text" :title="activity">{{activity}}</div>
                          <template v-slot="dot">
                            <div class="dot" :class="{ dot1: idx === 3}"></div>
							<div class="text" :title="activity">{{activity}}</div>
                          </template>
                        </el-timeline-item>
                      </el-timeline> -->
                    </div>
                    <div class="buy" v-if="item.ext2">
                      <a :href="item.ext2" target="_blank" rel="noopener noreferrer">直接购票</a>
                    </div>
                    <div class="buyMore" v-if="item.ext2">
                      <a @click="$openNewWindow('/new/service/route/info?id=' + item.id)">查看详情</a>
                    </div>
                  </div>
                  <div class="right" @click="$openNewWindow('/new/service/route/info?id=' + item.id)">
                    <cms-image :src="item._cover" fit="cover" class="img"></cms-image>
                    <div class="content">{{ item.intro }}</div>
                    <a class="more" @click="$openNewWindow('/new/service/route/info?id=' + item.id)">查看详情</a>
                  </div>
                  <div class="mask"></div>
                </div>
              </div>
          </template>
        </cms-article-list>
      </div>
      <!--主题产品-->
      <cms-column-list id="two" :pid="$cid.intro.zhuTiChanPin" class="two">
        <template slot-scope="{ list }">
          <div class="title"></div>
          <div class="contain">
            <div class="image vivify fadeIn" :style="{ backgroundImage: 'url(' + list[tabIndex].cover + ')' }"  @click="$openNewWindow('/new/service/production?id=' + list[tabIndex].id+'&tabIndex='+tabIndex)">
              <div class="overMask">
                <span>{{ list[tabIndex].note }}</span>
                <div class="more">
                  <a>MORE+</a>
                </div>
              </div>
            </div>
            <div class="tab">
              <div class="tab-item" :class="tabIndex===index?'active':''" v-for="(item, index) in list" :key="item.id" @click="tab(index)">{{ item.name }}</div>
            </div>
          </div>
        </template>
      </cms-column-list>
      <!--达人攻略-->
      <div class="three" id="three">
        <div class="title">
          <div class="more" @click="$openNewWindow('/new/service/strategy')">更多攻略</div>
        </div>
        <cms-article-list :pid="$cid.intro.daRenGongLue" :limit="3" class="contain">
          <template slot-scope="{ list }">
            <div class="con-item vivify fadeInRight" :class="'delay-'+index*500" v-for="(item,index) in list" :key="item.id" @click="$openNewWindow('/new/service/strategy/info?id=' + item.id)">
              <cms-image :src="item.cover" class="img"></cms-image>
              <div class="con-title">{{ item.title }}</div>
              <div class="rate">
                <span>推荐指数：</span>
                <el-rate v-model="item.star" :disabled="true"></el-rate>
              </div>
              <div class="content">
                {{ item.intro }}
              </div>
              <div class="more"></div>
            </div>
          </template>
        </cms-article-list>
      </div>
      <!--大峨眉度假旅游区-->
      <div class="four" id="four">
        <div class="title">
        </div>
        <cms-column-list :pid="$cid.intro.DaEMei" class="contain">
          <template slot-scope="{ list }">
            <div class="tab">
              <div class="tab-item" :class="tabIndex1===index?'active':''" v-for="(item, index) in list" :key="item.index" @click="tab1(index)">{{ item.name }}</div>
            </div>
            <cms-article-list :pid="list[tabIndex1].id" :sort-by="1" :parse-function="daemeiParse" class="content vivify fadeIn" v-if="list[tabIndex1]">
              <template slot-scope="arts">
                <div class="left" :class="'left'+tabIndex1">
                  <div class="address" v-for="(art, artIndex) in arts.list" :key="art.id" @mouseover="active1=artIndex" @mouseleave="active1=artIndex">
                    <span @click="websiteJump(art)">{{ artIndex+1 }}.{{ art.title}}</span>
                  </div>
                  <div class="text-grey">点击景区名称跳转至官网</div>
                </div>
                <div class="right" :style="{ backgroundImage: 'url(' + list[tabIndex1].cover + ')' }">
                  <div class="point point1" v-for="(art, artIndex) in arts.list" :key="art.id" :class="{ active: active1 === artIndex }" :style="{ top: art.top, right: art.right }" @mouseover="active1 = artIndex">
                    <cms-image class="img" :src="art.cover" @click="websiteJump(art)"></cms-image>
                    <!--<div class="img" :style="{ backgroundImage: art.cover }"></div>-->
                  </div>
                </div>
              </template>
            </cms-article-list>
          </template>
        </cms-column-list>
      </div>
      <zui-footer />
    </page>
    <router-view v-else></router-view>
  </div>
</template>
<script>
/** @format */

import './less/service.css';
import Logo from '../components/Logo';
import ZuiButton from '../components/Button';
import icon1 from '../assets/img/icon1.png';
import arrowGrey from '../assets/img/arrow-grey.png';
import add from '../assets/img/add.png';
// import Util from '../Util'
export default {
    components: {
        Logo,
        ZuiButton,
    },
    data() {
        return {
            xinLuParse: obj => {
                if (obj.ext1) {
                    obj.activities = obj.ext1.split('-');
                } else {
                    obj.activities = [];
                }
                if (obj.imgs) {
                    obj._cover = obj.imgs.split(',')[0];
                } else {
                    obj._cover = obj.cover;
                }
                return obj;
            },
            daemeiParse: obj => {
                if (obj.ext1) {
                    const [top, right] = obj.ext1.split(',');
                    obj.top = top;
                    obj.right = right;
                }
                return obj;
            },
            activities: [
                {
                    content: '报国寺/黄湾',
                    size: 'large',
                },
                {
                    content: '雷洞坪',
                    size: 'large',
                },
                {
                    content: '金顶',
                    size: 'large',
                },
                {
                    content: '报国寺/黄湾',
                    size: 'large',
                },
            ],
            active: 0,
            active1: 0,
            value1: 4,
            tabIndex: 0,
            tabIndex1: 0,
            carouselImg: [require('../assets/img/gonglue1.jpg'), require('../assets/img/gonglue3.jpg'), require('../assets/img/gonglue2.jpg')],
            icon1: icon1,
            arrowGrey: arrowGrey,
            activeName: 'second',
            add: add,
            navConfigList: [
                {
                    name: '经典<br>线路',
                    id: 'one',
                    height: '668',
                },
                {
                    name: '主题<br>产品',
                    id: 'two',
                    height: '1545',
                },
                {
                    name: '达人<br>攻略',
                    id: 'three',
                    height: '2214',
                },
                {
                    name: '大峨眉<br>旅游度<br>假区',
                    id: 'four',
                    height: '2950',
                },
            ],
        };
    },
    methods: {
        tab(index) {
            this.tabIndex = index;
        },
        tab1(index) {
            this.tabIndex1 = index;
        },
        websiteJump(item) {
            if (item.intro && item.intro.indexOf('http') === 0) {
                window.open(item.intro);
            }
        },
    },
};
</script>
<style>
/** @format */

.el-tabs__content {
    overflow: visible;
}

.el-tabs__item {
    color: white;
    font-size: 22px;
}

.el-tabs__item.is-active {
    color: #ffffff;
}

.el-tabs__header {
    border-bottom: 1px solid #85743c;
    padding-bottom: 30px;
}

.el-tabs__active-bar {
    height: 4px;
    border-radius: 2px;
    margin-top: 10px;
}

.el-icon-arrow-left {
    color: white;
}

.el-icon-arrow-right {
    color: white;
}

.el-tabs__nav-wrap::after {
    height: 0;
}

.el-tabs__active-bar {
    background-color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/views/service.vue